import { render, staticRenderFns } from "./ibClientTabs.vue?vue&type=template&id=33d4e30a&scoped=true"
import script from "./ibClientTabs.vue?vue&type=script&lang=js"
export * from "./ibClientTabs.vue?vue&type=script&lang=js"
import style0 from "./ibClientTabs.vue?vue&type=style&index=0&id=33d4e30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4e30a",
  null
  
)

export default component.exports